import Vue from "vue";
import Router from "vue-router";

import Home from "@/components/home/Home";
import Advisors from "@/components/advisors/Advisors";
import Contact from "@/components/contact/Contact";
import Services from "@/components/services/Services";
import Consultation from "@/components/contact/Consultation";
import DidYouKnow from "@/components/contact/DidYouKnow";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: "Chronicle Financial | Cherry Cheung - CFP Financial Advisor",
      },
    },
    {
      path: "/advisors",
      name: "Advisors",
      component: Advisors,
      meta: {
        title:
          "Chronicle Financial - Advisors | Cherry Cheung - CFP Financial Advisor",
      },
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
      meta: {
        title:
          "Chronicle Financial - Contact Us | Cherry Cheung - CFP Financial Advisor",
      },
    },
    {
      path: "/services",
      name: "Our Services",
      component: Services,
      meta: {
        title:
          "Chronicle Financial - Our Services | Cherry Cheung - CFP Financial Advisor",
      },
    },
    {
      path: "/didyouknow",
      name: "Did You Know?",
      component: DidYouKnow,
      meta: {
        title:
          "Chronicle Financial - About Us | Cherry Cheung - CFP Financial Advisor",
      },
    },
    {
      path: "/consultation",
      name: "Consultation",
      component: Consultation,
      meta: {
        title:
          "Chronicle Financial - Consultation | Cherry Cheung - CFP Financial Advisor",
      },
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
